import { render } from "./DialogOnetimeCodeComplete.vue?vue&type=template&id=ce91e486"
import script from "./DialogOnetimeCodeComplete.vue?vue&type=script&lang=js"
export * from "./DialogOnetimeCodeComplete.vue?vue&type=script&lang=js"
script.render = render

export default script